import React from "react";
import CheckDeliveryStatusTable from "./CheckDeliveryStatusTable";

const CheckDeliveryStatus = () => {
  const data = [
    {
      id: 1,
      asset_name: "Sager Howler",
      description: "test1 description",
      category: "test1 category",
      aid: 1,
    },
    {
      id: 2,
      asset_name: "Test User",
      description: "test2 description",
      category: "test2 category",
      aid: 2,
    },
    {
      id: 3,
      asset_name: "Test User2",
      description: "test3 description",
      category: "test3 category",
      aid: 3,
    },
  ];
  return (
    <>
      <CheckDeliveryStatusTable data={data} />
    </>
  );
};

export default CheckDeliveryStatus;
